import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import { exportToExcel } from "../../utils";
import CustomButton from "../custom-button";
import DownloadIcon from "@mui/icons-material/Download";
import { utils, writeFileXLSX } from "xlsx";

const DataExport = ({ header, data, fetchAllData, fileName, tableRef }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      if (fetchAllData) {
        let exportData = [];
        exportData = await fetchAllData();
        const formattedData = exportData.map((row) => {
          let formattedRow = {};
          header.forEach((col) => {
            if (!col?.notShowInReport) {
              if (col.columns) {
                col.columns.forEach((subCol) => {
                  formattedRow[subCol.label] = subCol.render
                    ? subCol.render(row)
                    : row[subCol.id];
                });
              } else {
                formattedRow[col.label] = col.render
                  ? col.render(row)
                  : row[col.id];
              }
            }
          });
          return formattedRow;
        });

        // Create a list of headers
        const headers = [];
        header.forEach((col) => {
          if (!col.notShowInReport) {
            if (col.columns) {
              col.columns.forEach((subCol) => {
                headers.push(subCol.label);
              });
            } else {
              headers.push(col.label);
            }
          }
        });

        exportToExcel(formattedData, fileName);
      } else {
        xport();
      }
    } finally {
      setLoading(false);
    }
  };
  const xport = () => {
    /* the .current field will be a TABLE element */
    const table_elt = tableRef.current;
    const wb = utils.table_to_book(table_elt);
    writeFileXLSX(wb, `${fileName}.xlsx`);
  };
  return (
    <div className="data-export-buttons">
      <CustomButton
        variant="contained"
        onClick={handleExport}
        disabled={loading}
        size="small"
        endIcon={<DownloadIcon />}
      >
        {loading ? <CircularProgress size={24} /> : "Export"}
      </CustomButton>
    </div>
  );
};

export default DataExport;
